import { Meteor } from 'meteor/meteor';
import { isNil, isEmpty } from 'lodash';

/**
 * Checks if user is authenticated in server.
 *
 * @param {string} [userId] - The user id to check.
 * @throws {Error} Meteor Error if the user cannot use this method.
 */
const checkAuthentication = (userId = Meteor.userId()) => {
  if (isNil(userId) || isEmpty(userId))
    throw new Meteor.Error('404', 'Sorry, you are not allowed to perform this action.');
};

export default checkAuthentication;
